export default __webpack_public_path__ + "static/media/Portal_Thumbs_Up.b9be3f3e.svg";